import { render, staticRenderFns } from "./supervisors.vue?vue&type=template&id=081586a5&"
import script from "./supervisors.vue?vue&type=script&lang=js&"
export * from "./supervisors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports